import { render, staticRenderFns } from "./MobFull.vue?vue&type=template&id=4ce610ee&scoped=true"
import script from "./MobFull.vue?vue&type=script&setup=true&lang=js"
export * from "./MobFull.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobFull.vue?vue&type=style&index=0&id=4ce610ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce610ee",
  null
  
)

export default component.exports